export default __webpack_public_path__ + "static/media/investment_active.c113c7a6.svg";